import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";


dayjs.extend(relativeTime);

dayjs.locale("ja");

export function formatDateFromNow(date: string) {
  return dayjs(date).fromNow();
}
